import React from "react";
import styled from "styled-components";
import { lightThemeColors } from "../../assets/style/colors";
import TitleDescriptionCard from "../generic/TitleDescriptionCard";
import { ReactComponent as ForkIcon4 } from "../../assets/icons/Fork4.svg";
const FragmentedMessaging = () => {
  const items = [
    {
      title: "Missed Engagement",
      description:
        "Delayed or unnoticed alerts result in lower engagement and frustrated customers.",
    },

    {
      title: "Fragmented Communication",
      description:
        "Messaging across platforms leads to missed alerts and inconsistent user experiences.",
    },

    {
      title: "Inconsistent Alerts",
      description:
        "Different systems create confusion, causing missed or delayed notifications.",
    },

    {
      title: "Tool Overload",
      description:
        "Managing multiple messaging tools complicates communication and increases maintenance.",
    },
  ];
  return (
    <FullPageContainer>
      <Container id={"fragmentedMessaging"}>
        <Content>
          <TextWrapper>
            <Title>The Cost of Fragmented Messaging</Title>
            <Subtitle>
              As a business, you need a unified messaging solution that delivers
              real-time alerts and notifications across mobile and web.
              Fragmented systems lead to missed messages, inconsistent
              notifications, and a disconnect with your customers, impacting
              engagement and satisfaction.
            </Subtitle>
          </TextWrapper>
          <RightSide>
            <ForkWrapper>
              <ForkIcon4 color="rgba(66, 0, 0, 0.55)" />
            </ForkWrapper>
            <ItemsWrapper>
              {items.map((item, index) => (
                <TitleDescriptionCard
                  key={index}
                  title={item.title}
                  description={item.description}
                />
              ))}
            </ItemsWrapper>
          </RightSide>
        </Content>
      </Container>
    </FullPageContainer>
  );
};

export default FragmentedMessaging;
const FullPageContainer = styled.div`
  display: flex;
  width: 100%;
  background: ${lightThemeColors.background};
  position: relative;
`;

const Container = styled.div`
  width: 100%;
  max-width: 1512px;
  margin-left: auto;
  margin-right: auto;
  z-index: 1;
  display: flex;
  flex-direction: column;
padding:100px 80px;
  gap: 100px;
  @media (max-width: 990px) {
    padding: 20px;
    gap: 30px;
  }
`;
const Content = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  gap: 30px;
  align-items: center;
  @media (max-width: 990px) {
    flex-direction: column;
  }
`;

const TextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 30px;
  max-width: 850px;
  @media (max-width: 990px) {
    max-width: unset;
  }
`;

const Title = styled.h1`
  color: ${lightThemeColors.darkColor};
  font-size: 36px;
  font-weight: 700;
  line-height: 46px;
  @media (max-width: 990px) {
    font-size: 30px;
    line-height: 36px;
    text-align: center;
  }
`;
const Subtitle = styled.p`
  color: ${lightThemeColors.darkColorFaded};
  font-size: 18px;
  font-weight: 400;
  line-height: 28px;
  @media (max-width: 990px) {
    font-size: 18px;
    line-height: 24px;
    text-align: center;
  }
`;

const ItemsWrapper = styled.div`
  display: flex;
  flex-direction: column;
    gap: 20px;
  overflow: hidden;
`;
const RightSide = styled.div`
  display: flex;
  align-items: center;
  height: 100%;
  width: 100%;
  gap: 10px;
`;
const ForkWrapper = styled.div`
  @media (max-width: 990px) {
    display: none;
  }
`;
